<template>
  <v-container class="expired-container fill-height" fluid>
    <v-row class="flex-column align-center justify-center" no-gutters>
      <v-col cols="auto" class="illustration-col">
        <svg
          width="220"
          height="180"
          viewBox="0 0 220 180"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="110" cy="40" r="28" fill="#FDE68A" />
          <circle cx="110" cy="40" r="20" fill="#FCD34D" />
          <line
            x1="110"
            y1="4"
            x2="110"
            y2="10"
            stroke="#FCD34D"
            stroke-width="2.5"
            stroke-linecap="round"
          />
          <line
            x1="110"
            y1="70"
            x2="110"
            y2="76"
            stroke="#FCD34D"
            stroke-width="2.5"
            stroke-linecap="round"
          />
          <line
            x1="74"
            y1="40"
            x2="80"
            y2="40"
            stroke="#FCD34D"
            stroke-width="2.5"
            stroke-linecap="round"
          />
          <line
            x1="140"
            y1="40"
            x2="146"
            y2="40"
            stroke="#FCD34D"
            stroke-width="2.5"
            stroke-linecap="round"
          />
          <line
            x1="84.6"
            y1="14.6"
            x2="88.8"
            y2="18.8"
            stroke="#FCD34D"
            stroke-width="2.5"
            stroke-linecap="round"
          />
          <line
            x1="131.2"
            y1="61.2"
            x2="135.4"
            y2="65.4"
            stroke="#FCD34D"
            stroke-width="2.5"
            stroke-linecap="round"
          />
          <line
            x1="135.4"
            y1="14.6"
            x2="131.2"
            y2="18.8"
            stroke="#FCD34D"
            stroke-width="2.5"
            stroke-linecap="round"
          />
          <line
            x1="88.8"
            y1="61.2"
            x2="84.6"
            y2="65.4"
            stroke="#FCD34D"
            stroke-width="2.5"
            stroke-linecap="round"
          />
          <rect x="75" y="90" width="70" height="55" rx="4" fill="#E7ECFF" />
          <polygon points="68,94 110,62 152,94" fill="#4C67DB" />
          <rect x="100" y="115" width="20" height="30" rx="3" fill="#4C67DB" />
          <circle cx="116" cy="132" r="2" fill="#E7ECFF" />
          <rect
            x="82"
            y="104"
            width="14"
            height="14"
            rx="2"
            fill="#FFFFFF"
            stroke="#4C67DB"
            stroke-width="1.5"
          />
          <line
            x1="89"
            y1="104"
            x2="89"
            y2="118"
            stroke="#4C67DB"
            stroke-width="1"
          />
          <line
            x1="82"
            y1="111"
            x2="96"
            y2="111"
            stroke="#4C67DB"
            stroke-width="1"
          />
          <rect
            x="124"
            y="104"
            width="14"
            height="14"
            rx="2"
            fill="#FFFFFF"
            stroke="#4C67DB"
            stroke-width="1.5"
          />
          <line
            x1="131"
            y1="104"
            x2="131"
            y2="118"
            stroke="#4C67DB"
            stroke-width="1"
          />
          <line
            x1="124"
            y1="111"
            x2="138"
            y2="111"
            stroke="#4C67DB"
            stroke-width="1"
          />
          <rect x="20" y="145" width="180" height="6" rx="3" fill="#E5E5E5" />
          <rect x="164" y="118" width="28" height="27" rx="4" fill="#EA580C" />
          <rect
            x="170"
            y="124"
            width="16"
            height="14"
            rx="2"
            fill="#FFF7ED"
            stroke="#EA580C"
            stroke-width="1"
          />
          <rect
            x="174"
            y="112"
            width="8"
            height="8"
            rx="3"
            fill="none"
            stroke="#EA580C"
            stroke-width="2"
          />
          <circle cx="170" cy="148" r="3" fill="#525252" />
          <circle cx="186" cy="148" r="3" fill="#525252" />
          <ellipse cx="38" cy="138" rx="12" ry="8" fill="#BBEDCA" />
          <rect x="36" y="138" width="4" height="10" rx="2" fill="#92D3A8" />
          <ellipse cx="38" cy="132" rx="8" ry="6" fill="#92D3A8" />
        </svg>
      </v-col>

      <v-col cols="auto" class="text-center mt-6">
        <h2 class="expired-title">Your stay has ended</h2>
      </v-col>

      <v-col cols="auto" class="text-center mt-2">
        <p class="expired-body">
          This reservation has checked out and the guest portal is no longer
          available.
        </p>
        <p class="expired-muted mt-2">We hope you had a wonderful time!</p>
      </v-col>

      <v-col cols="auto" class="mt-6">
        <div class="help-card">
          <div class="help-header">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <circle
                cx="10"
                cy="10"
                r="9"
                stroke="#4C67DB"
                stroke-width="1.5"
              />
              <line
                x1="10"
                y1="6"
                x2="10"
                y2="11"
                stroke="#4C67DB"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <circle cx="10" cy="14" r="1" fill="#4C67DB" />
            </svg>
            <span class="help-title">Need help?</span>
          </div>
          <p class="help-body">
            Questions about billing or need a receipt? Please reach out to your
            host directly.
          </p>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ReservationExpired',
}
</script>

<style lang="scss" scoped>
.expired-container {
  max-width: 480px;
  margin: 0 auto;
  padding: 40px 24px;
}

.expired-title {
  font-size: 24px;
  font-weight: 500;
  color: #161616;
  line-height: 1.2;
}

.expired-body {
  font-size: 15px;
  font-weight: 400;
  color: #525252;
  line-height: 1.5;
  max-width: 320px;
  margin: 0 auto;
}

.expired-muted {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  line-height: 1.5;
}

.help-card {
  background: #fafafa;
  border-radius: 12px;
  padding: 20px;
  max-width: 320px;
}

.help-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.help-title {
  font-size: 15px;
  font-weight: 500;
  color: #161616;
}

.help-body {
  font-size: 13px;
  color: #525252;
  line-height: 1.5;
  margin: 0;
}

.illustration-col {
  display: flex;
  justify-content: center;
}
</style>
